const SAFE_PACK_ID = /^[A-Za-z0-9][A-Za-z0-9_-]{0,127}$/;

export function normalizeStudyBuddyPracticeReference(value) {
  if (!value || typeof value !== "object") return null;
  const packType = value.pack_type;
  const packId = typeof value.pack_id === "string" ? value.pack_id.trim() : "";
  const scope = value.scope;
  if (!["private", "published"].includes(packType) || !SAFE_PACK_ID.test(packId) || !["pack", "topic"].includes(scope)) return null;
  if (scope === "topic") {
    const topicIndex = Number(value.topic_index);
    if (!Number.isInteger(topicIndex) || topicIndex < 0) return null;
    return { ...value, pack_type: packType, pack_id: packId, scope, topic_index: topicIndex };
  }
  const { topic_index, ...wholePack } = value;
  return { ...wholePack, pack_type: packType, pack_id: packId, scope };
}

export function parseStudyBuddyPracticeSearch(search = "") {
  const params = new URLSearchParams(search);
  if (!["pack_id", "pack_type", "scope", "topic_index"].some((name) => params.has(name))) return { present: false, reference: null };
  const reference = normalizeStudyBuddyPracticeReference({
    pack_id: params.get("pack_id"),
    pack_type: params.get("pack_type") || "private",
    scope: params.get("scope"),
    ...(params.has("topic_index") ? { topic_index: params.get("topic_index") } : {}),
  });
  return { present: true, reference };
}

export function sameStudyBuddyPracticeReference(left, right) {
  const a = normalizeStudyBuddyPracticeReference(left);
  const b = normalizeStudyBuddyPracticeReference(right);
  return Boolean(a && b && a.pack_type === b.pack_type && a.pack_id === b.pack_id && a.scope === b.scope && (a.scope !== "topic" || a.topic_index === b.topic_index));
}

export function studyBuddyPracticeUrl(path, value) {
  const reference = normalizeStudyBuddyPracticeReference(value);
  if (!reference) return path;
  const params = new URLSearchParams({
    pack_id: reference.pack_id,
    pack_type: reference.pack_type,
    scope: reference.scope,
  });
  if (reference.scope === "topic") params.set("topic_index", String(reference.topic_index));
  return `${path}?${params.toString()}`;
}

export function hydrateStudyBuddyPracticeSelection(reference, pack) {
  const normalized = normalizeStudyBuddyPracticeReference(reference);
  if (!normalized || !pack || typeof pack !== "object") return null;
  const topics = Array.isArray(pack.topics) ? pack.topics : [];
  if (normalized.scope === "topic") {
    const topic = topics[normalized.topic_index];
    if (!topic || !Array.isArray(topic.questions)) return null;
    return { ...normalized, title: pack.title || "Study Pack", scope_label: topic.title || `Topic ${normalized.topic_index + 1}`, question_count: topic.questions.length, access_tier: pack.access_tier, is_unlocked: pack.is_unlocked };
  }
  const questionCount = topics.reduce((total, topic) => total + (Array.isArray(topic?.questions) ? topic.questions.length : 0), 0);
  return { ...normalized, title: pack.title || "Study Pack", scope_label: "Entire Study Pack", question_count: questionCount, access_tier: pack.access_tier, is_unlocked: pack.is_unlocked };
}
